import { createIconComponent } from '../../factory/create-icon-component';
export const WarehouseIcon = createIconComponent(
  'WarehouseIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4605_28114)">
      <path
        d="M2.5 9.50001V17.2501C2.5 17.9468 2.5 18.2951 2.54329 18.587C2.80182 20.3298 4.17025 21.6982 5.91308 21.9568C6.20494 22.0001 6.55329 22.0001 7.25 22.0001L9.19182 22M1 11L7.47452 4.52549C9.05858 2.94142 9.85062 2.14939 10.7639 1.85263C11.5673 1.5916 12.4327 1.5916 13.2361 1.85263C14.1494 2.14939 14.9414 2.94142 16.5255 4.52549L23 11"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.75 20.917C11.75 21.8835 12.5335 22.667 13.5 22.667C14.4665 22.667 15.25 21.8835 15.25 20.917M11.75 20.917C11.75 19.9505 12.5335 19.167 13.5 19.167C14.4665 19.167 15.25 19.9505 15.25 20.917M11.75 20.917C11.2847 20.917 11.0517 20.9167 10.8634 20.8555C10.4828 20.7318 10.1845 20.4335 10.0608 20.0529C9.99966 19.8646 9.99966 19.632 9.99966 19.1667V13C9.99966 12.2999 9.99966 11.9499 10.1359 11.6825C10.2557 11.4473 10.447 11.2561 10.6822 11.1362C10.9496 11 11.2996 11 11.9997 11H13.9997C14.6997 11 15.0498 11 15.3172 11.1362C15.5524 11.2561 15.7436 11.4473 15.8634 11.6825C15.9997 11.9499 15.9997 12.2999 15.9997 13V14.5M15.25 20.917L17.583 20.9167M17.583 20.9167C17.583 21.8832 18.3665 22.667 19.333 22.667C20.2995 22.667 21.083 21.8828 21.083 20.9163M17.583 20.9167C17.583 20.7121 17.6181 20.5161 17.6826 20.3337C17.9775 19.6826 18.4252 19.167 19.333 19.167C20.2995 19.167 21.083 19.9498 21.083 20.9163M21.083 20.9163H21.233C21.7931 20.9163 22.0731 20.9163 22.287 20.8073C22.4752 20.7115 22.6281 20.5585 22.724 20.3703C22.833 20.1564 22.833 19.8764 22.833 19.3163V17.2837C22.833 16.8989 22.833 16.7064 22.8024 16.5193C22.7752 16.3532 22.7302 16.1906 22.668 16.0342C22.598 15.858 22.499 15.693 22.301 15.363L22.1334 15.0837C21.7731 14.4832 21.5929 14.1829 21.3513 13.9581C21.0834 13.7088 20.7606 13.526 20.4089 13.4245C20.0919 13.333 19.7417 13.333 19.0413 13.333H18.3827M19.792 16.2497H17.867C17.2136 16.2497 16.8869 16.2497 16.6373 16.1225C16.4178 16.0107 16.2393 15.8322 16.1275 15.6127C16.0003 15.3631 16.0003 15.0364 16.0003 14.383V13.333"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4605_28114">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>,
);
